import { trackError } from '../utils/trackError';
import { ECommerce4Transaction, TrackECommerceArg } from './types';
import { isGa4EcommerceData, isUaEcommerceData } from './utils';

export const ECOMMERCE_TRANSACTION_BOUNDARY = 'trackECommerceData';
export const ECOMMERCE_TRANSACTION_MESSAGE =
  'transactionId is required to correctly track eCommerce in Google Analytics 4';
export const handleECommerceTransactionDataError = (
  ga4Data: ECommerce4Transaction
) => {
  if (!ga4Data?.transaction_id) {
    trackError(
      new Error(ECOMMERCE_TRANSACTION_MESSAGE),
      ECOMMERCE_TRANSACTION_BOUNDARY
    );
  }
};

export const ECOMMERCE_BOUNDARY = 'trackECommerce';
export const ECOMMERCE_DATA_MESSAGE =
  'Cannot process eCommerce tracking if eCommerceData is not defined';
export const ECOMMERCE_INVALID_DATA_MESSAGE =
  'The provided eCommerce data are nor GA4 nor UA eCommerce data';
export const ECOMMERCE_ITEMS_MESSAGE =
  'eCommerce tracking will be performed without items';
export const checkECommerceDataError = (
  eCommerceData: TrackECommerceArg | ECommerce4Transaction
) => {
  if (!eCommerceData || Object.keys(eCommerceData).length === 0) {
    trackError(new Error(ECOMMERCE_DATA_MESSAGE), ECOMMERCE_BOUNDARY);
    return true;
  }
  if (!isGa4EcommerceData(eCommerceData) && !isUaEcommerceData(eCommerceData)) {
    trackError(new Error(ECOMMERCE_INVALID_DATA_MESSAGE), ECOMMERCE_BOUNDARY);
    return true;
  }
  if (isGa4EcommerceData(eCommerceData) && eCommerceData.items.length === 0) {
    trackError(new Error(ECOMMERCE_ITEMS_MESSAGE), ECOMMERCE_BOUNDARY);
    return true;
  }
  return false;
};

const CONFIRMATION_TMS_BOUNDARY = 'trackTMSConfirmation';
const CONFIRMATION_TMS_MESSAGE =
  'Cannot track TMS confirmation page without param ';
export const handleConfirmationTmsError = (paramName: string) => {
  trackError(
    new Error(CONFIRMATION_TMS_MESSAGE + paramName),
    CONFIRMATION_TMS_BOUNDARY
  );
};
